import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";

import { NAV_SURFACES } from "@/lib/nav";

// Left navigation. Every surface routes to a real page; one canonical layout per surface (no
// persona reshuffle). The active route is highlighted via NavLink's isActive.
export const SideNav = (): ReactNode => (
  <nav className="side-nav" aria-label="Surfaces">
    <div className="nav-section-label">Surfaces</div>
    {NAV_SURFACES.map((surface) => {
      const Icon = surface.icon;
      return (
        <NavLink
          key={surface.path}
          to={surface.path}
          end={surface.path === "/"}
          className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}
        >
          <span className="nav-accent" />
          <Icon size={16} aria-hidden />
          {surface.label}
        </NavLink>
      );
    })}
  </nav>
);
